import React from 'react';
import { Link, animateScroll as scroll } from 'react-scroll';
import '../styles/style.css';
import logo from '../images/logo0.png?webp={true}';
import ronewaBanner from "../images/adjusted_clolour.png?webp={true}";
import { BsList } from "react-icons/bs";
import { CgClose } from "react-icons/cg";
// import ronewa from "../images/with-circle-1_.webp?webp={true}";

export default function Banner() {
	const humbugerToggle = (e)=>{
		const body = document.querySelector('body');
		const hamburger = document.getElementById('hamburger');
		const menu = document.getElementById('menu');

		hamburger.classList.toggle('show');
		menu.classList.toggle('show');
		body.classList.toggle('noscroll');
	
	};
	const scrollToTop = () => {
		const body = document.querySelector('body');
    const hamburger = document.getElementById('hamburger');
    const menu = document.getElementById('menu');

		hamburger.classList.toggle('show');
		menu.classList.toggle('show');
		body.classList.toggle('noscroll');

		scroll.scrollToTop(); 
	};
  return (
    <div className="header home" id='page-top'>
			<div className="overlay has-fade"></div>
				<nav>
					<div className="container">
						<div className="flex justify-items-center align-items-center">
							<div className="img-wrapper">
								<a href="/" rel='noreferrer'>
									<img src={logo} alt={"logo"} decoding='async' />
								</a>
							</div>

							<button className="hamburger" id="hamburger">
								<span className="open">{<BsList onClick={(e)=>humbugerToggle(e)} size="2em"/>}</span>
								<span className="close">{<CgClose onClick={(e)=>humbugerToggle(e)} size="2em"/>}</span>
							</button>

							<ul id="menu" className="header__links">
								<li><Link activeClass="actives" to="home" spy={true} smooth={true} offset={-70} onClick={()=>scrollToTop()} style={buttonHover}>Home</Link></li>
								<li><Link activeClass="actives" to="about__me" spy={true} smooth={true} offset={-70} onClick={()=>scrollToTop()} style={buttonHover}>About</Link></li>
								<li><Link activeClass="active" to="skills" spy={true} smooth={true} offset={-70} onClick={()=>scrollToTop()} style={buttonHover}>Skills</Link></li>
								<li><Link activeClass="active" to="projects" spy={true} smooth={true} offset={-70} onClick={()=>scrollToTop()} style={buttonHover}>Project</Link></li>
								<li><Link activeClass="active" to="contact" spy={true} smooth={true} offset={-70} onClick={()=>scrollToTop()} style={buttonHover}>Contact</Link></li>
							</ul>
						</div>
					</div>
				</nav>
				<header>
					<div className="container">
						<div className="flex align-start justify-content-center align-items-center reverse-mobile">
							<div className="container--pill">
								<h1 className="line-top">
									Hi, I'm Ronewa
								</h1>
								<h2 className="">Full Stack Developer.</h2>
								<p className='Paragraph-sc-1tzuhix-0'>
									Results-driven Full-Stack Software Developer and IT Technician with over 6 years of hands-on experience building, maintaining, and enhancing enterprise web applications. Proficient in PHP, JavaScript, Java, 
									and modern frameworks including Laravel, React, Angular, and Spring Boot, with a strong foundation in both SQL and NoSQL databases. Proven ability to collaborate across cross-functional teams to deliver high-quality features on time, reduce system downtime, and improve user satisfaction. Holds a Microsoft Azure Fundamentals certification and actively pursues continuous professional development.
								</p>

								<a href='mailto:ronewamavhungu@gmail.com' rel='noreferrer' className="button hero__cta">
									Get in Touch
								</a>
							</div>

							<div>
								<img alt="mavhungu ronewa" loading="lazy" src={ronewaBanner} sizes={'max-width=100%'} className="ronewa-banner" fetchpriority="high" />
							</div>
						</div>
					</div>
				</header>
		</div>
	);
}

const buttonHover={
	cursor: 'pointer',
}
